import React from "react";

import {KPIComparisonControls} from "./KPIComparisonControls";
import KPITimeRangeControls from "./KPITimeRangeControls";
import Tooltip from "@mui/material/Tooltip";
import {Info} from "@mui/icons-material";


export const KPIPillColumnControls = ({
    title,
    tooltip,
    activeWindow,
    defaultEnd,
    defaultMiddle,
    defaultStart,
    disposition = "previous", // "previous" or "current"
    setActiveWindow,
    setUserDefinedWindow,
    userDefinedWindow,
}) => {

    return <div className={"kpi-grid-controls"}>
        <h2>{title}{tooltip ? <Tooltip title={tooltip}><Info className={"info-icon"}/></Tooltip> : ""}</h2>
        <div className={"product-detail-controls"}>
            {disposition === "both" ? <KPIComparisonControls
                activeWindow={activeWindow}
                userDefinedWindow={userDefinedWindow}
                setUserDefinedWindow={setUserDefinedWindow}
                setActiveWindow={setActiveWindow}
                defaultStart={defaultStart}
                defaultMiddle={defaultMiddle}
                defaultEnd={defaultEnd}
            /> : <KPITimeRangeControls
                activeWindow={activeWindow}
                disposition={disposition}  // "previous" or "current"
                setUserDefinedWindow={setUserDefinedWindow}
                userDefinedWindow={userDefinedWindow}
            />}
        </div>
    </div>
}